// Is a given variable an object?
export default function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isObject.js
// module id = 92
// module chunks = 106